module.exports = __webpack_public_path__ + "static/media/stars-3840.3e002053.jpg";